<p-dialog [visible]="showUploadDialog()" [modal]="true" [closable]="false">
  <ng-template #header>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4>{{ title() }}</h4>
      </div>
    </div>
  </ng-template>

  <ng-template #content>

    @if (hasInvalidFileNames()) {
      <div class="alert alert-danger d-flex flex-column" role="alert">
        <strong>
          <i class="pi pi-exclamation-triangle me-2"></i>
          Nombres de archivo inválidos
        </strong>
        <p class="mt-2 mb-2">Los siguientes archivos contienen espacios o caracteres especiales:</p>
        <ul class="mb-2">
          @for (fileName of invalidFileNames(); track fileName) {
            <li><code>{{ fileName }}</code></li>
          }
        </ul>
        <p class="mb-0">
          <small>
            <strong>Solo se permiten:</strong> letras, números, guiones (-), guiones bajos (_) y puntos (.)
          </small>
        </p>
      </div>
    }

    @if (hasUploadedFiles()) {
      <div class="d-flex flex-column mb-3">
        <div class="d-flex align-items-center mb-2">
          <i class="pi pi-check-circle me-2" style="font-size: 1.5rem; color: green;"></i>
          <h5 class="mb-0">Archivo(s) disponible(s).</h5>
        </div>

        <div class="list-group">
          @for (fileName of getCurrentUploadedFileNames(); track fileName) {
            <div class="list-group-item d-flex justify-content-between align-items-center gap-2">
              <a class="text-break" role="button" (click)="openWindowUploadHelp(fileName)">{{ fileName }}</a>
              <div class="d-flex gap-2 flex-shrink-0">
                <button class="btn btn-sm btn-outline-secondary" type="button" (click)="renameUploadedFile(fileName)">
                  Editar
                </button>
                <button class="btn btn-sm btn-outline-danger" type="button" (click)="deleteUploadedFile(fileName)">
                  Eliminar
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    }

    <p-fileupload
      #fileUpload
      [name]="getUploadFileFieldName()"
      [url]="getUploadUrl()"
      (onBeforeUpload)="onBeforeUpload($event)"
      (onUpload)="onUpload($event)"
      (onError)="onUploadError()"
      (onSelect)="onSelect($event)"
      [multiple]="options().multiple"
      [accept]="options().accept"
      [maxFileSize]="options().maxFileSize"
      [mode]="options().mode"
      [disabled]="hasInvalidFileNames() || !canUpload()"
    >
      <ng-template #empty>
        <div>Arrastra y suelta nuevos archivos aquí para subir.</div>
      </ng-template>
    </p-fileupload>

  </ng-template>

  <ng-template #footer>
    <div class="d-flex justify-content-end">
      <button class="btn btn-secondary" (click)="eventClose.emit()">
        Cerrar
      </button>
    </div>
  </ng-template>
</p-dialog>
